import { gameAction } from "_actions";
import { GameService } from "_services";
import i18n from "i18n";
import React, { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet";
import { Translation, useTranslation } from "react-i18next";
import { MdOutlineCasino } from "react-icons/md";
import { PiCoinsBold } from "react-icons/pi";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Loader } from "rsuite";
import { GiFootTrip, GiGoalKeeper } from "react-icons/gi";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation, FreeMode } from "swiper/modules";
import BannerCarousel from "./BannerCarousel";
import QuickAccess from "../QuickAccess/v3";
import BottomNavigation from "../BottomNavigation";
import PragmaticGameBox from "../GamerBoxes/PragmaticGameBox";
import DigitalOceanSpacesBox from "../GamerBoxes/DigitalOceanSpacesBox";
import WinningTicker from "./WinningTicker";

// Swiper CSS'lerini import et
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import MatGameBox from "../GamerBoxes/MatGameBox";
import Footer from "./Footer";
import BannerCarouselV2 from "./BannerCarouselV2";
import Ribbon from "./Ribbon";
import InnovaBox from "../GamerBoxes/InnovaBox";
import BannerCarouselV3 from "./BannerCarouselV3";

// Random eleman seçme fonksiyonu
const getRandomItems = (array, count) => {
  if (!array || array.length === 0) return [];
  const shuffled = [...array].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, Math.min(count, array.length));
};

const Home = (props) => {
  const { t } = useTranslation();
  const { user, loggedIn, games, UpdateSport, currentLang } = props;
  const [loading, setLoading] = useState(true);
  const [isError, setErrorStatus] = useState(false);
  const containerRef = useRef(null);
  const [isNavVisible, setIsNavVisible] = useState(true);

  // Banner verileri
  const banners = [
    {
      id: 1,
      img: require("../../../assets/img/home/slots.png"),
      gradient: "from-blue-600 to-blue-800",
      path: "/casino",
    },
    {
      id: 2,
      img: require("../../../assets/img/home/livecasino.png"),

      gradient: "from-secondary-600 to-secondary-800",
      path: "/live-casino",
    },
    {
      id: 3,
      img: require("../../../assets/img/home/womensports.png"),

      gradient: "from-green-600 to-green-800",
      path: "/",
    },
    {
      id: 4,
      img: require("../../../assets/img/home/jackpot1.png"),

      gradient: "from-purple-600 to-purple-800",
      path: "/my-account/",
    },
  ];

  const handleLoad = async () => {
    await setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  useEffect(() => {
    handleLoad();

    // Sadece sayfa ilk yüklendiğinde scroll pozisyonunu sıfırla
    // (login sonrası değil, gerçek sayfa yüklemesi)
    const isInitialLoad = !sessionStorage.getItem("homePageLoaded");
    if (isInitialLoad) {
      sessionStorage.setItem("homePageLoaded", "true");

      /*  if (containerRef.current) {
          containerRef.current.scrollTop = 0;
        }
        window.scrollTo(0, 0);*/
    }
  }, []);

  // Container hazır olduğunda scroll pozisyonunu kontrol et
  useEffect(() => {
    if (containerRef.current && !loading) {
      // Sadece ilk yüklemede scroll'u sıfırla
      const isInitialLoad = !sessionStorage.getItem("homePageLoaded");
      /* if (isInitialLoad) {
         setTimeout(() => {
           if (containerRef.current) {
             containerRef.current.scrollTop = 0;
           }
         }, 50);
       }*/
    }
  }, [loading]);
  /*
    useEffect(() => {
      // Smooth scroll için container'ı ayarla
      if (containerRef.current) {
        const container = containerRef.current;
  
        // Scroll event listener ekle
        const handleScroll = (e) => {
          // Smooth scroll davranışını koru
          e.preventDefault();
        };
  
        // Touch events için smooth scroll
        let startY = 0;
        let startScrollTop = 0;
  
        const handleTouchStart = (e) => {
          startY = e.touches[0].clientY;
          startScrollTop = container.scrollTop;
        };
  
        const handleTouchMove = (e) => {
          if (!startY) return;
  
          const currentY = e.touches[0].clientY;
          const diff = startY - currentY;
  
          // Smooth scroll with easing
          container.scrollTop = startScrollTop + diff;
        };
  
        const handleTouchEnd = () => {
          startY = 0;
          startScrollTop = 0;
        };
  
        container.addEventListener('touchstart', handleTouchStart, { passive: true });
        container.addEventListener('touchmove', handleTouchMove, { passive: true });
        container.addEventListener('touchend', handleTouchEnd, { passive: true });
  
        return () => {
          container.removeEventListener('touchstart', handleTouchStart);
          container.removeEventListener('touchmove', handleTouchMove);
          container.removeEventListener('touchend', handleTouchEnd);
        };
      }
    }, []);
  */
  const adjustHeight = () => {
    try {
      const navbarHeight = document.querySelector(".base-nav")?.offsetHeight;
      const navbarHeight1 = document.querySelector(".base-nav1")?.offsetHeight;
      const windowHeight = window.innerHeight;

      if (containerRef && containerRef.current) {
        const h =
          windowHeight -
          (navbarHeight > navbarHeight1 ? navbarHeight : navbarHeight1);
        containerRef.current.style.height = `${h}px`;
      }
      /*   if (!document.hidden && containerRef.current) {
           containerRef.current.scrollTop = 0;
           window.scrollTo(0, 0);
         }*/
    } catch (error) {}
  };

  return (
    <Translation>
      {(t) => (
        <>
          <div
            style={{
              overflow: "auto",
              height: "calc(100dvh - 80px)", // Sadece header için alan bırakıyoruz
              WebkitOverflowScrolling: "touch", // iOS için smooth scroll
              backgroundImage: `url(${require("../../../assets/img/bg.jpg")})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              paddingBottom: "calc(120px + env(safe-area-inset-bottom))", // Footer ve BottomNavigation için extra alan
            }}
            ref={containerRef}
            className="bg-secondary-500 home-container"
            onLoad={adjustHeight}
          >
            <Helmet>
              <title>{"KurdBetDax"}</title>
            </Helmet>

            {/* Top Banner Area - Swiper.js Carousel */}
            <BannerCarouselV3 banners={banners} />
            <Ribbon />
            {/*
                  <div className="py-2"/>
            <WinningTicker />
              */}
            {/**
               <Ribbon /> 
               
               <QuickAccess />
              */}
            <QuickAccess />

            <Footer />
          </div>

          {props.permissions && (
            <BottomNavigation
              //   permissions={props.permissions}
              isNavVisible={isNavVisible && !loading}
            />
          )}

          {loading && (
            <div className="bg-secondary-800/80 h-screen w-screen  absolute top-0 z-[100]">
              <div className="flex flex-col mt-2 opacity-40 mobile-show">
                <div className="flex mb-2 justify-between">
                  <div className="skeleton w-[4rem] h-[4rem]" />
                  <div className="skeleton w-[4rem] h-[4rem]" />
                  <div className="skeleton w-[4rem] h-[4rem]" />
                  <div className="skeleton w-[4rem] h-[4rem]" />
                  <div className="skeleton w-[4rem] h-[4rem]" />
                </div>
                <div className="skeleton w-[100vw] h-[14rem] mb-2" />
                <div className="flex mb-2 justify-between">
                  <div className="skeleton w-[4rem] h-[4rem]" />
                  <div className="skeleton w-[4rem] h-[4rem]" />
                  <div className="skeleton w-[4rem] h-[4rem]" />
                  <div className="skeleton w-[4rem] h-[4rem]" />
                  <div className="skeleton w-[4rem] h-[4rem]" />
                </div>
                <div className="skeleton w-[100vw] h-[14rem]" />
              </div>
              <div className="h-screen w-screen flex flex-col justify-center items-center absolute top-0">
                <img
                  width={200}
                  height={200}
                  className="fade-in"
                  src={require("../../../assets/img/gamebox1.png")}
                />
                <span className="mt-6 loading loading-spinner loading-md"></span>
              </div>
            </div>
          )}
        </>
      )}
    </Translation>
  );
};

const mapStateToProps = (state, props) => {
  const { authentication, game } = state;
  const { user, loggedIn, currentLang, permissions } = authentication;
  const { sports, games } = game;
  return {
    user,
    loggedIn,
    sports,
    games,
    permissions,
    currentLang,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    UpdateSport: (data) => dispatch(gameAction.UpdateSportsData(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
